import React, { useState } from 'react';
import SupportForm from './SupportForm';
import './Support.css';

const SupportLauncher = ({ user }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSupport = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button 
        className="support-launcher"
        onClick={toggleSupport}
        title="Kontakta support"
      >
        <i className="fas fa-question-circle"></i>
      </button>

      {isOpen && (
        <SupportForm 
          user={user}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default SupportLauncher;